import { render, staticRenderFns } from "./WareNote.vue?vue&type=template&id=501fa120&scoped=true&"
import script from "./WareNote.vue?vue&type=script&lang=js&"
export * from "./WareNote.vue?vue&type=script&lang=js&"
import style0 from "./WareNote.vue?vue&type=style&index=0&id=501fa120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501fa120",
  null
  
)

export default component.exports